import { parseData, post } from './common';
import { responseHandler } from '../api/api';
const getUserRecords = (FilterParameters) => post('/InternalAPI/ManageUsersAPI.asmx/GetUserRecords', {
    FilterParameters
})
    .then(parseData)
    .then(responseHandler);
const getUserDetail = (UserID) => post('/InternalAPI/ManageUsersAPI.asmx/GetUserDetail', {
    UserID
})
    .then(parseData)
    .then(responseHandler);
const saveUserDetail = (UserDetail) => post('/InternalAPI/ManageUsersAPI.asmx/SaveUserDetail', {
    UserDetail
})
    .then(parseData)
    .then(responseHandler);
const hasBillingIncreaseMessage = () => post('/InternalAPI/ManageUsersAPI.asmx/HasBillingIncreaseMessage')
    .then(parseData)
    .then(responseHandler);
const resendWelcomeEmail = (UserID) => post('/InternalAPI/ManageUsersAPI.asmx/ResendWelcomeEmail', {
    UserID
})
    .then(parseData)
    .then(responseHandler);
const setTemporaryPassword = (UserID, Password) => post('/InternalAPI/ManageUsersAPI.asmx/SetTemporaryPassword', {
    UserID,
    Password
})
    .then(parseData)
    .then(responseHandler);
const createTemporaryLoginURL = (UserID) => post('/InternalAPI/ManageUsersAPI.asmx/CreateTemporaryLoginURL', {
    UserID
})
    .then(parseData)
    .then(responseHandler);
const assumeUserIdentity = (UserID) => post('/InternalAPI/ManageUsersAPI.asmx/AssumeUserIdentity', {
    UserID
})
    .then(parseData)
    .then(responseHandler);
const getApprovers = (ExcludeUsrID) => post('/InternalAPI/ManageUsersAPI.asmx/GetApprovers', {
    ExcludeUsrID
})
    .then(parseData)
    .then(responseHandler);
const getAccountants = (ExcludeUsrID) => post('/InternalAPI/ManageUsersAPI.asmx/GetAccountants', {
    ExcludeUsrID
})
    .then(parseData)
    .then(responseHandler);
const getDepartments = () => post('/InternalAPI/ManageUsersAPI.asmx/GetDepartments').then(parseData).then(responseHandler);
const getEmployeeGLDs = (Index) => post('/InternalAPI/ManageUsersAPI.asmx/GetEmployeeGLDs', {
    Index
})
    .then(parseData)
    .then(responseHandler);
const getEmployeeGLDLabels = () => post('/InternalAPI/ManageUsersAPI.asmx/GetEmployeeGLDLabels')
    .then(parseData)
    .then(responseHandler);
const getSessionURL = (UserIDs) => post('/InternalAPI/ManageUsersAPI.asmx/GetSessionURL', {
    UserIDs
})
    .then(parseData)
    .then(responseHandler);
const disableManageUsers = () => post('/InternalAPI/ManageUsersAPI.asmx/DisableManageUsers')
    .then(parseData)
    .then(responseHandler);
const getBulkUploadLink = () => post('/InternalAPI/ManageUsersAPI.asmx/GetBulkUploadLink')
    .then(parseData)
    .then(responseHandler);
const getTreasurerAvailable = () => post('/InternalAPI/ManageUsersAPI.asmx/GetTreasurerAvailable')
    .then(parseData)
    .then(responseHandler);
const sendWelcomeEmails = (UserIDs) => post('/InternalAPI/ManageUsersAPI.asmx/SendWelcomeEmails', {
    UserIDs
})
    .then(parseData)
    .then(responseHandler);
const getApprovalLimits = () => post('/InternalAPI/ManageUsersAPI.asmx/GetApprovalLimits')
    .then(parseData)
    .then(responseHandler);
const getSettlementAccount = () => post('/InternalAPI/ManageUsersAPI.asmx/GetSettlementAccount')
    .then(parseData)
    .then(responseHandler);
const getUserCount = () => post('/InternalAPI/ManageUsersAPI.asmx/GetUserCount').then(parseData).then(responseHandler);
const getUserRecordsXLSXBytes = (FilterParameters) => post('/InternalAPI/ManageUsersAPI.asmx/GetUserRecordsXLSXBytes', {
    FilterParameters
})
    .then(parseData)
    .then(responseHandler);
const getApprovalWorkFlowCount = (WorkflowFilter) => post('/InternalAPI/ManageUsersAPI.asmx/GetApprovalWorkFlowCount', {
    WorkflowFilter
})
    .then(parseData)
    .then(responseHandler);
const getExpCatMaxOverride = (UserID) => post('/InternalAPI/ManageUsersAPI.asmx/GetExpCatMaxOverride', {
    UserID
})
    .then(parseData)
    .then(responseHandler);
const getFilteredUserCount = (FilterParameters) => post('/InternalAPI/ManageUsersAPI.asmx/GetFilteredUserCount', {
    FilterParameters
})
    .then(parseData)
    .then(responseHandler);
export { getUserRecords, getUserDetail, saveUserDetail, hasBillingIncreaseMessage, resendWelcomeEmail, setTemporaryPassword, createTemporaryLoginURL, assumeUserIdentity, getApprovers, getAccountants, getDepartments, getEmployeeGLDs, getEmployeeGLDLabels, getSessionURL, disableManageUsers, getBulkUploadLink, getTreasurerAvailable, sendWelcomeEmails, getApprovalLimits, getSettlementAccount, getUserCount, getUserRecordsXLSXBytes, getApprovalWorkFlowCount, getExpCatMaxOverride, getFilteredUserCount };
